/**
 * @module profile/components/portfolio/entry_details_component
 */
import React, { Component, PropTypes } from 'react';
import { v4 } from 'node-uuid';
import { LoadingIndicator } from 'common/components/preloader';
import SingleEntryDetails from 'common/components/modal/single_entry_details';
import PinchView from 'common/components/pinch_view';

/**
 * Details component for the portfolio single entry.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
class EntryDetailsComponent extends Component {
  /*
   * Creates element to be rendered in the left drawer.
   *
   * @returns {object} object with css class and element to render
   */
  getLeftDrawer() {
    let element = null;
    let classes = '';

    return {
      element,
      classes,
    };
  }

  /*
   * Creates element to be rendered as the main content.
   *
   * @returns {object} object with element to render
   */
  getContent() {
    const { detailsState, entry, onZoomIn, onZoomOut, onToggleFullscreen } = this.props;
    const elements = [];

    if (!entry || detailsState.showPreloader) {
      elements.push(<LoadingIndicator />);
    } else {
      elements.push(
        <PinchView
          key={v4()}
          debug={false}
          imageSize={{ width: entry.width, height: entry.height }}
          zoom={detailsState.zoom}
          maxScale={detailsState.maxScale}
          onZoomIn={onZoomIn}
          onZoomOut={onZoomOut}
          onToggleFullscreen={onToggleFullscreen}
        >
          <img
            data-tip
            src={entry.image}
            alt={entry.description}
          />
        </PinchView>
      );
    }

    return {
      elements,
    };
  }

  render() {
    const leftDrawerData = this.getLeftDrawer();
    const contentData = this.getContent();

    return (
      <SingleEntryDetails
        leftDrawer={leftDrawerData}
        mainContent={contentData}
        detailsState={this.props.detailsState}
      />
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} entry - entry data object
 * @property {object} userAccess - object with user privileges
 * @property {object} detailsState - object with instance data for rendering purposes
 * @property {func} onZoomIn - function called when zoom-in button is clicked
 * @property {func} onZoomOut - function called when zoom-out button is clicked
 * @property {func} onToggleFullscreen - function called when the fullscreen button is clicked
 * @property {func} onToggleLeftDrawer - function called when we're to toggle the left drawer
 */
EntryDetailsComponent.propTypes = {
  entry: PropTypes.object,
  userAccess: PropTypes.object,
  detailsState: PropTypes.object,
  onZoomIn: PropTypes.func,
  onZoomOut: PropTypes.func,
  onToggleFullscreen: PropTypes.func,
  onToggleLeftDrawer: PropTypes.func,
};

export default EntryDetailsComponent;



// WEBPACK FOOTER //
// ./profile/components/portfolio/entry_details_component.jsx